import ConcreteTexture from '@/components/base/ConcreteTexture';

/** トップ以外の下層ページ用。コンクリート打ちっぱなし背景をページ全体に敷く */
export default function SubPageShell({ children }: { children: React.ReactNode }) {
  return (
    <main className="relative isolate w-full min-h-screen">
      <ConcreteTexture />
      <div className="relative z-10">{children}</div>
    </main>
  );
}
